/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/radio-button/custom-elements';

import { defineCustomElement as defineOsdsRadioButton } from '@ovhcloud/ods-stencil/components/radio-button/custom-elements/osds-radio-button.js';

export const OsdsRadioButton = /*@__PURE__*/createReactComponent<JSX.OsdsRadioButton, HTMLOsdsRadioButtonElement>('osds-radio-button', undefined, undefined, defineOsdsRadioButton);
